import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker } from "@material-ui/pickers";
import ChipInput from "material-ui-chip-input";
import ReportsTaxonomySelector from "./../taxonomy/ReportsTaxonomySelector";
import CoreFilter from "./CoreFilter";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { connect } from "react-redux";
import { Badge } from "@material-ui/core";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import IconButton from "@material-ui/core/IconButton";
import ListItemText from "@material-ui/core/ListItemText";
import KpsListItem from "../../core-elements/KpsListItem";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import Table from "@material-ui/core/Table";

const styles = (theme) => ({
  container: {},
  paperRoot: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
  },
  gridContainer: {
    alignItems: "center",
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    width: "100%",
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
export class FilterReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultFilters: [
        "taxonomy",
        "titleContains",
        "draft",
        "requiresReval",
        "modifiedInLast",
        "createdInLast",
      ],
      titleContains: "",
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,
    };
  }

  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.sort = (
        this.props.asPopper === true && (
          <div className={classes.formControl}>
            <FormControl className={classes.sortBy}>
              <InputLabel htmlFor="sort">
                <Trans i18nKey="global_sort" />
              </InputLabel>
              <Select
                value={this.props.filter.sort}
                onChange={this.props.handleSortChange}
                inputProps={{
                  name: "sort",
                  id: "sort",
                }}
              >
                <MenuItem value="none">
                  <Trans i18nKey="filter_discussions_sort_none" />
                </MenuItem>
                <MenuItem value="title">
                  <Trans i18nKey="global_document_title" />
                </MenuItem>
                <MenuItem value="viewed">
                  <Trans i18nKey="global_view_past_tense" />
                </MenuItem>
                <MenuItem value="lastViewedByMe">
                  <Trans i18nKey="settings_document_date_last_viewed_by_me" />
                </MenuItem>
                <MenuItem value="liked">
                  <Trans i18nKey="global_like_past_tense" />
                </MenuItem>
                <MenuItem value="favourited">
                  <Trans i18nKey="global_favourite_past_tense" />
                </MenuItem>
                <MenuItem value="used">
                  <Trans i18nKey="settings_document_number_of_times_used" />
                </MenuItem>
                {/* <MenuItem value="isViewed"><Trans i18nKey="global_view_past_tense"></Trans></MenuItem> */}
                {/* <MenuItem value="isUsed"><Trans i18nKey="global_use_past_tense"></Trans></MenuItem> */}
                <MenuItem value="createdDate">
                  <Trans i18nKey="global_filter_created_date" />
                </MenuItem>
                <MenuItem value="modifiedDate">
                  <Trans i18nKey="global_filter_modified_date" />
                </MenuItem>
                <MenuItem value="revalidationDate">
                  <Trans i18nKey="settings_document_revalidation_date" />
                </MenuItem>
              </Select>
            </FormControl>
            <Button onClick={this.props.toggleSortDirection}>
              {this.props.filter.sortDirection === "ASC" ? (
                <>
                  <ArrowUpwardIcon />
                </>
              ) : (
                <>
                  <ArrowDownwardIcon />
                </>
              )}
            </Button>
          </div>
        )
    );
    filterObj.taxonomy = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <ReportsTaxonomySelector
          multiSelect={true}
          allowedSelections={["taxonomy", "topic"]}
          filter={this.getFilters()}
          onNodeSelected={this.props.setTaxonomy}
        />
      </FormControl>
    );
    filterObj.titleContains = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("titleContains") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TextField
          value={this.state.titleContains ? this.state.titleContains : ""}
          onChange={(e) =>
            this.setState(
              { titleContains: e.target.value },
              this.props.handleChange(e)
            )
          }
          label="Title contains..."
          name="titleContains"
        />
      </FormControl>
    );
    filterObj.favourited = (
      <FormControlLabel
        key={"iFavourited"}
        control={
          <Checkbox
            checked={this.props.filter.favourited === true}
            onChange={this.props.handleCheckboxChange("favourited")}
            value="onlyFavourited"
          />
        }
        label={t("filter_documents_i_favourited")}
      />
    );
    filterObj.liked = (
      <FormControlLabel
        key={"iLiked"}
        control={
          <Checkbox
            checked={this.props.filter.liked === true}
            onChange={this.props.handleCheckboxChange("liked")}
            value={this.props.filter.liked}
          />
        }
        label={t("filter_documents_i_liked")}
      />
    );
    filterObj.viewed = (
      <FormControlLabel
        key={"iViewed"}
        control={
          <Checkbox
            checked={this.props.filter.viewed === true}
            onChange={this.props.handleCheckboxChange("viewed")}
            value="onlyViewed"
          />
        }
        label={t("filter_documents_i_viewed")}
      />
    );
    filterObj.modifiedSinceLastSeen = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.modifiedSinceLastSeen === true}
            onChange={this.props.handleCheckboxChange("modifiedSinceLastSeen")}
            value="onlyModifiedSinceLastSeen"
          />
        }
        label={t("filter_documents_were_modified_since_last_seen")}
      />
    );
    filterObj.draft = (
      <>
        {(this.props.currentUser.userPermits.roles.beExpert ||
          this.props.currentUser.userPermits.roles.systemManager) &&
          (!this.props.disabledFilters ||
            this.props.disabledFilters.indexOf("draft") === -1) && (
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="live-draft">
                <Trans i18nKey="search_bar_live_draft" />
              </InputLabel>
              <Select
                value={this.props.filter.draft}
                onChange={this.props.handleChange}
                inputProps={{
                  name: "draft",
                  id: "draft",
                }}
              >
                <MenuItem value="Any">
                  <Trans i18nKey="global_all" />
                </MenuItem>
                <MenuItem value="Live">
                  <Trans i18nKey="global_document_live" />
                </MenuItem>
                <MenuItem value="Draft">
                  <Trans i18nKey="global_document_draft" />
                </MenuItem>
              </Select>
            </FormControl>
          )}
      </>
    );
    filterObj.modifiedInLast = (
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="modifiedInLast">
          <Trans i18nKey="filter_documents_modified_in_the_last" />
        </InputLabel>
        <Select
          value={this.props.filter.modifiedInLast}
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "modifiedInLast",
            id: "modifiedInLast",
          }}
        >
          <MenuItem value={0}>
            <Trans i18nKey="global_all" />
          </MenuItem>
          <MenuItem value={7}>
            <Trans i18nKey="filter_documents_dates_last_7_days" />
          </MenuItem>
          <MenuItem value={30}>
            <Trans i18nKey="filter_documents_dates_last_30_days" />
          </MenuItem>
          <MenuItem value={90}>
            <Trans i18nKey="filter_documents_dates_last_90_days" />
          </MenuItem>
        </Select>
      </FormControl>
    );
    filterObj.createdInLast = (
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="createdInLast">
          <Trans i18nKey="filter_documents_created_in_the_last" />
        </InputLabel>
        <Select
          value={this.props.filter.createdInLast}
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "createdInLast",
            id: "createdInLast",
          }}
        >
          <MenuItem value={0}>
            <Trans i18nKey="global_all" />
          </MenuItem>
          <MenuItem value={7}>
            <Trans i18nKey="filter_documents_dates_last_7_days" />
          </MenuItem>
          <MenuItem value={30}>
            <Trans i18nKey="filter_documents_dates_last_30_days" />
          </MenuItem>
          <MenuItem value={90}>
            <Trans i18nKey="filter_documents_dates_last_90_days" />
          </MenuItem>
        </Select>
      </FormControl>
    );
    filterObj.createdStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdEnd
              ? moment(this.props.filter.createdEnd)
              : null
          }
          onChange={this.props.handleDateChange("createdEnd")}
        />
      </FormControl>
    );
    filterObj.createdEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdStart
              ? moment(this.props.filter.createdStart)
              : null
          }
          onChange={this.props.handleDateChange("createdStart")}
        />
      </FormControl>
    );
    filterObj.modifiedEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_before")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedEnd
              ? moment(this.props.filter.modifiedEnd)
              : null
          }
          onChange={this.props.handleDateChange("modifiedEnd")}
        />
      </FormControl>
    );
    filterObj.modifiedStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_after")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedStart
              ? moment(this.props.filter.modifiedStart)
              : null
          }
          onChange={this.props.handleDateChange("modifiedStart")}
        />
      </FormControl>
    );

    // filterObj.createdBy = (
    //   <ChipInput
    //     className={classes.chipInput}
    //     fullWidthInput
    //     value={this.props.filter.createdBy}
    //     onAdd={(chip) => this.props.addChip("createdBy", chip)}
    //     onDelete={(chip) => this.props.deleteChip("createdBy", chip)}
    //     label={t("filter_entries_created_by")}
    //   />
    // );
    // filterObj.modifiedBy = (
    //   <ChipInput
    //     className={classes.chipInput}
    //     fullWidthInput
    //     value={this.props.filter.modifiedBy}
    //     onAdd={(chip) => this.props.addChip("modifiedBy", chip)}
    //     onDelete={(chip) => this.props.deleteChip("modifiedBy", chip)}
    //     label={t("filter_documents_modified_by")}
    //   />
    // );
    filterObj.requiresReval = (
      <>
        {(this.props.currentUser.userPermits.roles.beExpert ||
          this.props.currentUser.userPermits.roles.moderator ||
          this.props.currentUser.userPermits.roles.systemManager) && (
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="requiresReval">
              <Trans i18nKey="content_setup_requires_revalidation" />
            </InputLabel>
            <Select
              value={
                this.props.filter.requiresReval
                  ? this.props.filter.requiresReval
                  : "Any"
              }
              onChange={this.props.handleSelectChange}
              inputProps={{
                name: "requiresReval",
                id: "requiresReval",
              }}
            >
              <MenuItem value="Any">
                <Trans i18nKey="global_all" />
              </MenuItem>
              <MenuItem value="RequiresRevalidation">
                <Trans i18nKey="content_setup_requires_revalidation" />
              </MenuItem>
              <MenuItem value="DoesNotRequireRevalidation">
                {"Does not Require Revalidation"}
              </MenuItem>
            </Select>
          </FormControl>
        )}
      </>
    );
  //   const activeFilters = (
  //     <>
  //       {!this.state.opened &&
  //         Object.keys(this.props.filter)
  //           .filter((filter) => this.props.isFilterSet(filter))
  //           .map((filter, idx) => (
  //             <Grid item>
  //               {filterObj.hasOwnProperty(filter) &&
  //                 this.state.defaultFilters.indexOf(filter) < 0 &&
  //                 filterObj[filter]}
  //             </Grid>
  //           ))}
  //     </>
  //   );
  //   const inActiveFilters = (
  //     <>
  //       {this.state.opened &&
  //         Object.keys(filterObj).map((filter, idx) => (
  //           <Grid item>
  //             {filterObj.hasOwnProperty(filter) &&
  //               this.state.defaultFilters.indexOf(filter) < 0 &&
  //               filterObj[filter]}
  //           </Grid>
  //         ))}
  //     </>
  //   );
  //   let defaultFilters = (
  //     <>
  //       <span>
  //         <IconButton
  //           onClick={this.props.resetToDefaultFilters}
  //           size="large"
  //           color={this.props.showReset === true ? "secondary" : "default"}
  //           disabled={this.props.showReset === false}
  //         >
  //           <Icon
  //             path={
  //               this.props.showReset === true
  //                 ? mdiFilterVariantRemove
  //                 : mdiFilterVariant
  //             }
  //             size={1.5}
  //           />
  //         </IconButton>
  //       </span>
  //       <>
  //         {this.state.defaultFilters.map((filter, idx) => (
  //           <Grid item>
  //             {filterObj.hasOwnProperty(filter) && filterObj[filter]}
  //           </Grid>
  //         ))}
  //       </>
  //     </>
  //   );
  //   return (
  //     <>
  //       {this.props.asPopper ? (
  //         <MuiPickersUtilsProvider utils={MomentUtils}>
  //           {this.props.filter !== null && (
  //             <div style={{ width: "100%" }}>
  //               {this.props.showReset && (
  //                 <Button
  //                   className={classes.resetButton}
  //                   onClick={this.props.resetToDefaultFilters}
  //                 >
  //                   <Trans i18nKey="filters_reset_to_default" />
  //                 </Button>
  //               )}
  //               <ExpansionPanel
  //                 expanded={expanded === "sort"}
  //                 onChange={this.props.handleExpansionPanelChange("sort")}
  //               >
  //                 <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  //                   <Typography className={classes.heading}>
  //                     <Trans i18nKey="global_sort" />
  //                   </Typography>
  //                   <Typography className={classes.secondaryHeading}>
  //                     <Trans i18nKey="filter_documents_sort_secondary_heading" />
  //                   </Typography>
  //                 </ExpansionPanelSummary>
  //                 <ExpansionPanelDetails>
  //                   {filterObj.sort}
  //                 </ExpansionPanelDetails>
  //               </ExpansionPanel>

  //               <ExpansionPanel
  //                 expanded={expanded === "basic"}
  //                 onChange={this.props.handleExpansionPanelChange("basic")}
  //               >
  //                 <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  //                   <Typography className={classes.heading}>
  //                     <Trans i18nKey="global_basic" />
  //                   </Typography>
  //                   <Typography className={classes.secondaryHeading}>
  //                     <Trans i18nKey="filter_documents_basic_secondary_heading" />
  //                   </Typography>
  //                 </ExpansionPanelSummary>
  //                 <ExpansionPanelDetails>
  //                   <FormControl
  //                     component="fieldset"
  //                     className={classes.formControl}
  //                   >
  //                     <FormLabel component="legend">
  //                       <Trans i18nKey="filter_documents_only_show_documents_that" />
  //                     </FormLabel>
  //                     <FormGroup row>
  //                       {filterObj.favourited}
  //                       {filterObj.liked}
  //                       {filterObj.viewed}
  //                     </FormGroup>
  //                     <FormGroup row>
  //                       {filterObj.modifiedSinceLastSeen}
  //                       {filterObj.requiresReval}
  //                     </FormGroup>
  //                     <FormGroup>{filterObj.draft}</FormGroup>
  //                     <FormGroup>{filterObj.titleContains}</FormGroup>
  //                   </FormControl>
  //                 </ExpansionPanelDetails>
  //               </ExpansionPanel>

  //               <ExpansionPanel
  //                 expanded={expanded === "dates"}
  //                 onChange={this.props.handleExpansionPanelChange("dates")}
  //               >
  //                 <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  //                   <Typography className={classes.heading}>
  //                     <Trans i18nKey="global_sort_dates" />
  //                   </Typography>
  //                   <Typography className={classes.secondaryHeading}>
  //                     <Trans i18nKey="filter_documents_dates_secondary_heading" />
  //                   </Typography>
  //                 </ExpansionPanelSummary>
  //                 <ExpansionPanelDetails>
  //                   <div className={classes.datesContainer}>
  //                     <FormGroup row>
  //                       {filterObj.modifiedInLast}
  //                       {filterObj.createdInLast}
  //                     </FormGroup>
  //                     <FormGroup row>
  //                       {filterObj.createdStart}
  //                       {filterObj.createdEnd}
  //                     </FormGroup>
  //                     <FormGroup row>
  //                       {filterObj.modifiedStart}
  //                       {filterObj.modifiedEnd}
  //                     </FormGroup>
  //                   </div>
  //                 </ExpansionPanelDetails>
  //               </ExpansionPanel>

  //               <ExpansionPanel
  //                 expanded={expanded === "sections"}
  //                 onChange={this.props.handleExpansionPanelChange("sections")}
  //               >
  //                 <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  //                   <Typography className={classes.heading}>
  //                     <Trans i18nKey="global_section_plural" />
  //                   </Typography>
  //                   <Typography className={classes.secondaryHeading}>
  //                     <Trans i18nKey="filter_documents_sections_secondary_heading" />
  //                   </Typography>
  //                 </ExpansionPanelSummary>
  //                 <ExpansionPanelDetails>
  //                   {filterObj.taxonomy}
  //                 </ExpansionPanelDetails>
  //               </ExpansionPanel>

  //               <ExpansionPanel
  //                 expanded={expanded === "users"}
  //                 onChange={this.props.handleExpansionPanelChange("users")}
  //               >
  //                 <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  //                   <Typography className={classes.heading}>
  //                     <Trans i18nKey="global_user_plural" />
  //                   </Typography>
  //                   <Typography className={classes.secondaryHeading}>
  //                     <Trans i18nKey="filter_documents_users_secondary_heading" />
  //                   </Typography>
  //                 </ExpansionPanelSummary>
  //                 <ExpansionPanelDetails>
  //                   <div className={classes.userChipsWrapper}>
  //                     {filterObj.createdBy}
  //                     {filterObj.modifiedBy}
  //                   </div>
  //                 </ExpansionPanelDetails>
  //               </ExpansionPanel>
  //             </div>
  //           )}
  //         </MuiPickersUtilsProvider>
  //       ) : (
  //         // <Paper classes={{ root: classes.paperRoot }}>
  //         // <KpsListItem
  //         //   onToggle={(expanded) => this.setState({ opened: expanded })}
  //         //   isPortlet={false}
  //         //   preText={this.props.preText}
  //         //   provided={this.props.provided}
  //         //   onItemClick={(event) => event && event.stopPropagation()}
  //         //   onItemChange={(event) => event && event.stopPropagation()}
  //         //   extendedString={
  //         //     <>
  //         //       <Grid container classes={{root:classes.gridContainer}}>{inActiveFilters}</Grid>
  //         //     </>
  //         //   }
  //         // >
  //         //   {this.props.preText}
  //         //   <ListItemText
  //         //     primary={<Grid container classes={{root:classes.gridContainer}}>{defaultFilters}{activeFilters}</Grid>}
  //         //     secondary={""}
  //         //   />
  //         // </KpsListItem>
  //         <div>
  //           <ListItem
  //             className={classes.listItem}
  //             style={{
  //               paddingLeft: this.props.preText ? 0 : 10,
  //               borderRight: this.props.selected
  //                 ? `2px solid ${this.props.theme.palette.primary.main}`
  //                 : "",
  //             }}
  //             ContainerComponent="div"
  //             disableGutters={true}
  //             dense={true}
  //             selected={false}
  //           >
  //             {this.props.preText}
  //             <ListItemText
  //               primary={
  //                 <Grid container classes={{ root: classes.gridContainer }}>
  //                   {defaultFilters}
  //                   {activeFilters}
  //                 </Grid>
  //               }
  //               secondary={""}
  //             />
  //             {!this.props.hideExpand && (
  //               <IconButton onClick={this.toggleExpand}>
  //                 {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  //               </IconButton>
  //             )}
  //           </ListItem>
  //           <Collapse in={this.state.opened} timeout="auto" unmountOnExit>
  //             <Table size="small">
  //               <>
  //                 <Grid container classes={{ root: classes.gridContainer }}>
  //                   {inActiveFilters}
  //                 </Grid>
  //               </>
  //             </Table>
  //           </Collapse>
  //         </div>
  //       )}
  //     </>
  //   );
  // }
  // toggleExpand = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   this.setState((prev) => ({ opened: !prev.opened }));
  // };
  let activeFilters = (
    <>
      {!this.state.opened &&
        Object.keys(this.props.filter)
          .filter((filter) => this.props.isFilterSet(filter))
          .map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 &&
              filterObj[filter] && (
                <Grid
                  item
                  xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                  sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                  lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 2}
                  classes={{ root: classes.gridItem }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
    </>
  );
  let inActiveFilters = (
    <>
      {this.state.opened &&
        Object.keys(filterObj).map(
          (filter, idx) =>
            filterObj.hasOwnProperty(filter) &&
            this.state.defaultFilters.indexOf(filter) < 0 &&
            filterObj[filter] && (
              <Grid
                item
                xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 2}
                classes={{ root: classes.gridItem }}
                style={{ maxWidth: this.props.isMobile && "100%" }}
              >
                {filterObj[filter]}
              </Grid>
            )
        )}
    </>
  );
  let defaultFilters = (
    <>
      <>
        {this.state.defaultFilters.map(
          (filter, idx) =>
            filterObj.hasOwnProperty(filter) &&
            filterObj[filter] && (
              <Grid
                item
                xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 2}
                classes={{ root: classes.gridItem }}
                style={{ maxWidth: this.props.isMobile && "100%" }}
              >
                {filterObj[filter]}
              </Grid>
            )
        )}
      </>
    </>
  );
  return (
    <>
      {this.props.asPopper ? (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          {this.props.filter !== null && (
            <div style={{ width: "100%" }}>
              {this.props.showReset && (
                <Button
                  className={classes.resetButton}
                  onClick={this.props.resetToDefaultFilters}
                >
                  <Trans i18nKey="filters_reset_to_default" />
                </Button>
              )}
              <ExpansionPanel
                expanded={expanded === "sort"}
                onChange={this.props.handleExpansionPanelChange("sort")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_sort" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_sort_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {filterObj.sort}
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "basic"}
                onChange={this.props.handleExpansionPanelChange("basic")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_basic" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_basic_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel component="legend">
                      <Trans i18nKey="filter_documents_only_show_documents_that" />
                    </FormLabel>
                    <FormGroup row>
                      {filterObj.favourited}
                      {filterObj.liked}
                      {filterObj.viewed}
                    </FormGroup>
                    <FormGroup row>
                      {filterObj.modifiedSinceLastSeen}
                      {filterObj.requiresReval}
                    </FormGroup>
                    <FormGroup>{filterObj.draft}</FormGroup>
                    <FormGroup>{filterObj.documentTypes}</FormGroup>
                    <FormGroup>{filterObj.categories}</FormGroup>
                    <FormGroup>{filterObj.titleContains}</FormGroup>
                  </FormControl>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "dates"}
                onChange={this.props.handleExpansionPanelChange("dates")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_sort_dates" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_dates_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className={classes.datesContainer}>
                    <FormGroup row>
                      {filterObj.modifiedInLast}
                      {filterObj.createdInLast}
                    </FormGroup>
                    <FormGroup row>
                      {filterObj.createdStart}
                      {filterObj.createdEnd}
                    </FormGroup>
                    <FormGroup row>
                      {filterObj.modifiedStart}
                      {filterObj.modifiedEnd}
                    </FormGroup>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "sections"}
                onChange={this.props.handleExpansionPanelChange("sections")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_section_plural" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_sections_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {filterObj.taxonomy}
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {/* <ExpansionPanel
                expanded={expanded === "users"}
                onChange={this.props.handleExpansionPanelChange("users")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_user_plural" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_users_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className={classes.userChipsWrapper}>
                    {filterObj.createdBy}
                    {filterObj.modifiedBy}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel> */}
            </div>
          )}
        </MuiPickersUtilsProvider>
      ) : (
        // <Paper classes={{ root: classes.paperRoot }}>
        // <KpsListItem
        //   onToggle={(expanded) => this.setState({ opened: expanded })}
        //   isPortlet={false}
        //   preText={this.props.preText}
        //   provided={this.props.provided}
        //   onItemClick={(event) => event && event.stopPropagation()}
        //   onItemChange={(event) => event && event.stopPropagation()}
        //   extendedString={
        //     <>
        //       <Grid container classes={{root:classes.gridContainer}}>{inActiveFilters}</Grid>
        //     </>
        //   }
        // >
        //   {this.props.preText}
        //   <ListItemText
        //     primary={<Grid container classes={{root:classes.gridContainer}}>{defaultFilters}{activeFilters}</Grid>}
        //     secondary={""}
        //   />
        // </KpsListItem>
        <div>
          <ListItem
            button
            onClick={(event) => event && event.stopPropagation()}
            className={classes.listItem}
            style={{
              paddingLeft: this.props.preText ? 0 : 10,
              borderRight: this.props.selected
                ? `2px solid ${this.props.theme.palette.primary.main}`
                : "",
            }}
            ContainerComponent="div"
            disableGutters={true}
            dense={true}
            selected={false}
          >
            {this.props.preText}
            <ListItemText
              primary={
                <>
                  <div className={classes.filterWrapper}>
                    <span>
                      <IconButton
                        onClick={this.props.resetToDefaultFilters}
                        size="large"
                        color={
                          this.props.showReset === true
                            ? "secondary"
                            : "default"
                        }
                        disabled={this.props.showReset === false}
                      >
                        <Icon
                          path={
                            this.props.showReset === true
                              ? mdiFilterVariantRemove
                              : mdiFilterVariant
                          }
                          size={1.5}
                        />
                      </IconButton>
                    </span>
                    <div className={classes.filterWrapper}>
                      <Collapse
                        in={this.state.menuCollapseOpened}
                        timeout="auto"
                        unmountOnExit
                        style={{ width: "100%" }}
                      >
                        <Grid
                          container
                          classes={{ root: classes.gridContainer }}
                          style={{
                            flexDirection: this.props.isMobile && "column",
                          }}
                        >
                          {defaultFilters}
                          {activeFilters}
                          <Collapse
                            in={this.state.opened}
                            timeout="auto"
                            unmountOnExit
                            style={{ width: "100%" }}
                          >
                            <Grid
                              container
                              classes={{ root: classes.gridContainer }}
                              style={{
                                flexDirection:
                                  this.props.isMobile && "column",
                              }}
                            >
                              {inActiveFilters}
                            </Grid>
                          </Collapse>
                        </Grid>
                      </Collapse>
                    </div>
                  </div>
                </>
              }
              secondary={""}
            />
            {!this.props.hideExpand && (
              <IconButton onClick={this.toggleExpand}>
                {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </ListItem>
        </div>
      )}
    </>
  );
}

toggleExpand = (e) => {
  e.preventDefault();
  e.stopPropagation();
  this.props.isMobile && this.props.menuDialog
    ? this.setState((prev) => ({
        menuCollapseOpened: !prev.menuCollapseOpened,
      }))
    : this.setState((prev) => ({ opened: !prev.opened }));
};
  getFilters = () => {
    let filters = this.props.filter.taxonomy
      ? this.props.filter.taxonomy.length > 0
        ? this.props.filter.taxonomy
        : this.props.taxonomyNodeLookup
      : this.props.taxonomyNodeLookup;
    return filters;
  };
}
const mapStateToProps = (state) => ({
  documentTypes: state.prefs.documentTypes,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterReports))));
